import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import {BillingOrderService} from "../../../billing-accounts/services/billing-order.service";
import * as _ from "lodash";
import {DeliverySchedulingForm} from "../../models/delivery-scheduling-form.model";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {OmsDialogService} from "../../services/oms-dialog-service.service";
import {OmsOrdersAlertsService} from "../../services/oms-orders-alerts.service";
import {OmsRequestsService} from "../../services/oms-requests.service";
import {OmsService} from "../../services/oms-service.service";
import {BillingAccountDialogService} from "../../../billing-accounts/services/billing-account-dialog-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {ProNumberDialogService} from "../../../commons/services/pro-number-dialog-service.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {FulfillmentDialogService} from "../../../fulfillment/services/fulfillment-dialogs-service.service";
import {FulfillmentFacadeService} from "../../../fulfillment/angular/services/fulfillment-facade.service";
import {Subscription} from "rxjs";
import {FulfillmentModel} from "../../../fulfillment/models/fulfillment.model";
import {OrdersFacadeService} from "../../angular/service/orders-facade.service";
import {OrderModel} from "../../models/order.model";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {OperationalContactModel} from "../../../commons/angular/models/operational-contact.model";


export class OmsOrderViewController implements IController {

  order: any;
  doDispatch: boolean;
  autoDispatch: boolean;

  public canDispatch = true;
  public sections: any;
  public fulfillmentLines: any;
  public fulfillment: FulfillmentModel;
  public billingOrder: any;
  public isPricingOfferEnabled: boolean;
  public isEditPriceMode: boolean;
  public orderInfo: any;
  public orderInfoLoading: boolean;
  public isPickupTaskScheduled: boolean;
  public isDropOffTaskScheduled: boolean;
  public deliverySchedulingForm: DeliverySchedulingForm;
  public orderNotes: any;
  public orderPackages: any;
  public orderMetaData: any;
  public dynamicColumnsMap: any;
  public editableMetaData?: {key: string, value: string};
  public orderFulfillmentLinesAdditions: {} = {};
  public dispatchStepIds: string[];
  public canSendToDispatch: boolean;
  public selectedFulfillmentSubscription: Subscription;
  public orderSubscription: Subscription;


  /* @ngInject */
  constructor(private $state, private $fulfillment, private billingOrderService: BillingOrderService,
              private bringozLoaderService: BringozLoaderService, private $billingAccounts, private fulfillmentDialogService: FulfillmentDialogService,
              private confirmDialogService: ConfirmDialogService, private proNumberDialogService: ProNumberDialogService, private $log, private omsService: OmsService,
              private omsOrdersAlertsService: OmsOrdersAlertsService, private omsDialogService: OmsDialogService, private omsRequestsService: OmsRequestsService,
              private splitService: SplitService, private moment, private billingAccountDialogService: BillingAccountDialogService,
              public fulfillmentFacadeService: FulfillmentFacadeService, private $timeout: ITimeoutService, private ordersFacadeService: OrdersFacadeService,
              private commonsDialogService: CommonsDialogService) {
  }

  $onInit() {
    this.orderMetaData = this.splitService.getOmsMetadataSettings();
    this.dynamicColumnsMap = _.mapKeys(this.order.metaData, (value, key) => {
      return value.key;
    });
    this.sections = {
      orderPackages: false
    }
    if (this.order.fulfillmentId) {
      this.getFulfillment(this.order.fulfillmentId);
      this.getOrderInfo(this.order.id);
    }

    if (this.order.fulfillmentId && this.autoDispatch) {
      this.omsService.autoDispatchOrder(this.order.id)
    }

    if (this.order.billingOrderId) {
      this.getBillingOrder(this.order.billingOrderId);
    }

    // this.$fulfillment(fulfillmentId).$instantGet({expand: true})
    //   .then((fulfillment) => {
    //     this.fulfillment = angular.copy(fulfillment);
    //     this._addStepNumberToFulfillment(this.fulfillment);
    //     if (fulfillment.fulfillmentSteps.length > 1) {
    //       this.isPickupTaskScheduled = this.isTaskScheduled(fulfillment.fulfillmentSteps[0].status);
    //       this.isDropOffTaskScheduled = this.isTaskScheduled(fulfillment.fulfillmentSteps[fulfillment.fulfillmentSteps.length - 1].status);
    //     } else {
    //       const isTaskScheduled = this.isTaskScheduled(fulfillment.fulfillmentSteps[0].status);
    //       this.isPickupTaskScheduled = isTaskScheduled;
    //       this.isDropOffTaskScheduled = isTaskScheduled;
    //     }
    //   })

    this.fulfillmentFacadeService.subscribeToChannels();

    this.ordersFacadeService.subscribeToChannels();
    this.ordersFacadeService.setMany([this.order]);
    this.orderSubscription = this.ordersFacadeService.selectOne(this.order.id).subscribe((order: OrderModel) => {
      if (!!order) {

        if (!_.isEqual(order.fulfillmentId, this.order.fulfillmentId) ||
          !_.isEqual(order.status, this.order.status)) {
          if (order.fulfillmentId) {
            this.getFulfillment(order.fulfillmentId);
          }
          this.getOrderInfo(order.id);
        }

        if (!_.isEqual(order.billingOrderId, this.order.billingOrderId)) {
          this.getBillingOrder(order.billingOrderId);
        }

        if (!_.isEqual(order.fulfillmentId, this.order.fulfillmentId) && this.autoDispatch) {
          this.omsService.autoDispatchOrder(order.id)
        }

        this.order = angular.copy(order);

        this.$timeout(0).then(() => {
        });
      }
    })


  }

  $onChanges(changes) {
    // if (changes.order && !changes.order.isFirstChange()) {
    //   const orderCurrentValue = _.get(changes, 'order.currentValue', undefined),
    //     orderPreviousValue = _.get(changes, 'order.previousValue', undefined);
    //   if (!_.isEqual(orderCurrentValue.fulfillmentId, orderPreviousValue.fulfillmentId) ||
    //     !_.isEqual(orderCurrentValue.status, orderPreviousValue.status)) {
    //     if (this.order.fulfillmentId) {
    //       this.getFulfillment(this.order.fulfillmentId);
    //     }
    //     this.getOrderInfo(this.order.id);
    //   }
    //   if (!_.isEqual(orderCurrentValue.billingOrderId, orderPreviousValue.billingOrderId)) {
    //     this.getBillingOrder(this.order.billingOrderId);
    //   }
    //   if (!_.isEqual(orderCurrentValue.fulfillmentId, orderPreviousValue.fulfillmentId) && this.autoDispatch) {
    //     this.omsService.autoDispatchOrder(this.order.id)
    //   }
    // }
  }

  $onDestroy() {
    this.selectedFulfillmentSubscription?.unsubscribe();
    this.fulfillmentFacadeService.removeAll();
    this.orderSubscription?.unsubscribe();
    this.ordersFacadeService.unsubscribeFromChannels();
    this.ordersFacadeService.removeAll();
  }

  onReloadFulfillment(fulfillmentId) {
    this.doDispatch = false;
    this.getFulfillment(fulfillmentId);
  }

  onTogglePricingOfferMode() {
    this.isPricingOfferEnabled = !this.isPricingOfferEnabled;

    if (!this.isPricingOfferEnabled) {
      this.isEditPriceMode = false;
    }
  }

  onSetEditPricingMode(isEdit) {
    this.isEditPriceMode = isEdit;
  }

  onClosePricingOfferMode() {
    this.isPricingOfferEnabled = false;
    this.isEditPriceMode = false;
  }

  onCreateInvoice($event) {
    this.bringozLoaderService.on();
    this.$billingAccounts(this.billingOrder.accountReference.billingAccountId).$asyncValue()
      .then((billingAccount) => {
        this._openCreateInvoiceDialog($event, billingAccount);
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  onDeleteInvoice(billingOrder, $event) {
    this.billingAccountDialogService.deleteInvoice($event, billingOrder)
      .then(() => {
        this._deleteInvoice(billingOrder.id);
      })
  }

  updateOrder(updatedOrder) {
    this.order = updatedOrder;
  }


  onEditOperationalContacts() {
    this.commonsDialogService.editOperationalContacts(this.order.operationalContacts || [])
      .then((operationalContacts: OperationalContactModel[]) => {
        this.omsService.updateOperationalContacts(this.order.id, operationalContacts)
          .then((updatedOrder: OrderModel) => {
            this.order = updatedOrder;
          });
      });
  }

  onEditProNumber() {
    this.proNumberDialogService.editProNumberDialog(this.order.fulfillmentLines[0].proNumber)
      .then((editedProNumber) => {
        this._updateServiceProNumber(editedProNumber);
      })
      .catch((err) => {
        this.$log.info('Dialog Closed', err);
      })
  }

  onAssign() {
    this.omsDialogService.assignOrder(this.order.id)
      .then((supplier) => {
        this.assignToSupplier(this.order.id, supplier);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onSendToDispatch(event) {
    if (!this.dispatchStepIds?.length) {
      return;
    }
    this.fulfillmentDialogService.dispatchStep(this.fulfillment, this.dispatchStepIds, event)
      // .then((newStep) => {
      //   this.onReloadFulfillment(this.fulfillment.id)
      // })
      .catch((error) => {
        this.$log.debug('Failed to dispatch step', error);
      })
  }

  onLineSelectionChange(stepIds) {
    this.dispatchStepIds = stepIds;
    this.canSendToDispatch = !!stepIds?.length;
  }

  onAddNote($event) {
    this.omsDialogService.addNote($event, this.order.id)
      .then((note) => {
        this._addNote(note);
      })
      .catch((error) => {
        this.$log.info('Dialog Closed');
      })
  }

  onViewSchedulingLink() {
    this.omsService.getSchedulingForm(this.order.id)
      .then((deliverySchedulingForm: DeliverySchedulingForm) => {
        this.deliverySchedulingForm = deliverySchedulingForm;
      });
  }

  onRemoveSchedulingForm() {
    this.deliverySchedulingForm = undefined;
  }

  onFulfillmentUpdate(updatedFulfillment) {
    this.fulfillment = updatedFulfillment;
  }

  onDeleteNote(noteId) {
    this.omsService.onDeleteOrderNote(this.order.id, noteId);
  }

  onEditMetaData(key: string, value?: string) {
    this.editableMetaData = {key : key, value: value};
  }

  onCancelEditMetaData() {
    this.editableMetaData = undefined;
  }

  onEditableMetaDataValueChange(value) {
    this.editableMetaData.value = value;
  }

  onSaveMetaData(editableMetaData: {key: string, value: string}) {
    const metaDataCopy = angular.copy(this.order.metaData) || [];
    const metaDataIndex = metaDataCopy.findIndex((m: {key: string, value?: string}) => {
      return m.key === editableMetaData.key;
    })
    if (metaDataIndex > -1) {
      metaDataCopy[metaDataIndex] = editableMetaData;
    } else {
      metaDataCopy.push(editableMetaData);
    }
    this._updateMetaData(metaDataCopy)
  }

  ///////////// private methods //////////////


  private assignToSupplier(orderId, supplier) {
    this.omsService.assignToSupplier(orderId, supplier)
      .then(() => {
      })
      .catch((error) => {
        this.$log.error('Failed to assign an order to supplier', error);
      })
  }

  private _addNote(note) {
    this.omsService.addNote(this.order.id, note)
      .then(() => {

      })
      .catch((error) => {
        this.$log.error('Failed to add note to order', error);
      })
  }

  private getFulfillment(fulfillmentId) {
    // this.$fulfillment(fulfillmentId).$instantGet({expand: true})
    //   .then((fulfillment) => {
    //     this.fulfillment = angular.copy(fulfillment);
    //     this._addStepNumberToFulfillment(this.fulfillment);
    //     if (fulfillment.fulfillmentSteps.length > 1) {
    //       this.isPickupTaskScheduled = this.isTaskScheduled(fulfillment.fulfillmentSteps[0].status);
    //       this.isDropOffTaskScheduled = this.isTaskScheduled(fulfillment.fulfillmentSteps[fulfillment.fulfillmentSteps.length - 1].status);
    //     } else {
    //       const isTaskScheduled = this.isTaskScheduled(fulfillment.fulfillmentSteps[0].status);
    //       this.isPickupTaskScheduled = isTaskScheduled;
    //       this.isDropOffTaskScheduled = isTaskScheduled;
    //     }
    //   })
    this.fulfillmentFacadeService.removeAll();
    this.fulfillmentFacadeService.getOne(fulfillmentId, true);
    this.selectedFulfillmentSubscription = this.fulfillmentFacadeService.selectOne(fulfillmentId)
      .subscribe((fulfillment: FulfillmentModel) => {
        if (!!fulfillment) {
          this.fulfillment = angular.copy(fulfillment);
          this._addStepNumberToFulfillment(this.fulfillment);
          if (fulfillment.fulfillmentSteps.length > 1) {
            this.isPickupTaskScheduled = this.isTaskScheduled(fulfillment.fulfillmentSteps[0]?.status);
            this.isDropOffTaskScheduled = this.isTaskScheduled(fulfillment.fulfillmentSteps[fulfillment.fulfillmentSteps.length - 1].status);
          } else {
            const isTaskScheduled = this.isTaskScheduled(fulfillment.fulfillmentSteps[0]?.status);
            this.isPickupTaskScheduled = isTaskScheduled;
            this.isDropOffTaskScheduled = isTaskScheduled;
          }
          this.$timeout(0).then(() => {
          });
        }
      })
  }

  private isTaskScheduled(stepStatus) {
    return stepStatus === 'Scheduled' || stepStatus === 'Completed' || stepStatus === 'Dispatched';
  }

  private getBillingOrder(billingOrderId) {
    this.billingOrderService.getBillingOrder(billingOrderId)
      .then((billingOrder) => {
        this.billingOrder = billingOrder;
      })
  }

  private getOrderInfo(orderId) {
    this.orderInfoLoading = true;
    this.omsService.getOrderInfo(orderId)
      .then(info => {
        this.orderInfo = info;
      })
      .finally(() => {
        this.orderInfoLoading = false;
      })
  }

  private _updateServiceProNumber(proNumber: string) {
    if (this.order.fulfillmentLines[0].proNumber === proNumber) return;

    let orderCopy = angular.copy(this.order);
    orderCopy.fulfillmentLines[0].proNumber = proNumber;

    this.bringozLoaderService.on();
    if (orderCopy.status === 'Completed') {
      this.omsService.updateCompletedOrder(orderCopy.id, orderCopy)
        .then((updatedOrder) => {
          this.omsOrdersAlertsService.updateSuccess();
          this.order = updatedOrder;
        })
        .catch((error) => {
          this.omsOrdersAlertsService.updateError(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    } else {
      this.omsRequestsService.updateOrder(orderCopy.id, orderCopy)
        .then((updatedOrder) => {
          this.omsOrdersAlertsService.updateSuccess();
          this.order = updatedOrder;
        })
        .catch((error) => {
          this.omsOrdersAlertsService.updateError(error);
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    }
  }

  private _openCreateInvoiceDialog($event, billingAccount) {
    this.billingAccountDialogService.createInvoice($event, [this.billingOrder.id], billingAccount)
      .then((invoicePayload) => {
        invoicePayload.billingAccountId = this.billingOrder.accountReference.billingAccountId;
        this._createInvoice(invoicePayload);
      })
  }

  private _createInvoice(invoicePayload) {
    this.billingOrderService.createInvoice(invoicePayload)
      .then(() => {
      })
  }

  private _deleteInvoice(billingOrderId) {
    this.billingOrderService.deleteInvoice(billingOrderId)
      .then((res) => {
        this.billingOrder = angular.copy(res);
      })
  }

  private _addStepNumberToFulfillment(fulfillment) {
    _.forEach(fulfillment.fulfillmentSteps, (s, index) => {
      s.stepNumber = index + 1
    })
  }

  private _updateMetaData(metaData: {key: string, value: string}[]) {
    this.omsService.updateOrderMetaData(this.order.id, metaData)
      .then((updatedOrder: OrderModel) => {
        this.dynamicColumnsMap = _.mapKeys(updatedOrder.metaData, (value, key) => {
          return value.key;
        });
        this.editableMetaData = undefined;
      })
  }


}

angular
  .module('bringoz.admin.oms')
  .component('omsOrderView', {
    bindings: {
      order: '<',
      doDispatch: '<?',
      autoDispatch: '<?'
    },
    template: require('./oms-order-view.html').default,
    controller: OmsOrderViewController
  });
